/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  transition: {
    duration: {
      short: "100ms",
      default: "200ms",
      long: "400ms",
    },
    "timing-function": "ease-in-out",
  },
  color: {
    primary: {
      10: "#fff3f3",
      30: "#ff7370",
      50: "#fc5757",
      70: "#d4524f",
      90: "#a63633",
    },
    secondary: {
      10: "#ecf3f4",
      30: "#0f6378",
      50: "#035266",
      90: "#014554",
    },
    tertiary: {
      10: "#e3f8fb",
      30: "#a8eaf3",
      50: "#00c0db",
      70: "#00aac1",
    },
    quaternary: {
      10: "#fffbed",
      30: "#fccf5e",
      50: "#ffc200",
      70: "#f0b021",
      100: "#d29614",
    },
    brand: {
      primary: {
        10: "#ffe5fc",
        30: "#ffb0f7",
        50: "#ff91f0",
        70: "#eb73de",
      },
      secondary: {
        10: "#e4eaff",
        30: "#264ffa",
        50: "#0529fc",
        70: "#0833bd",
      },
    },
    neutral: {
      10: "#fcfcfc",
      20: "#f7f7f5",
      30: "#e0ded9",
      40: "#737370",
      50: "#4b4b4b",
      60: "#333330",
      70: "#181818",
    },
    success: {
      10: "#f2f8e9",
      50: "#81b928",
      90: "#659b1c",
    },
    information: {
      10: "#eaf5ff",
      50: "#2fa0fc",
      90: "#175db5",
    },
    warning: {
      10: "#fef6e7",
      50: "#f2a10c",
      90: "#ae6606",
    },
    error: {
      10: "#fceaea",
      50: "#e02d2d",
      90: "#a1162e",
    },
    ai: {
      primary: {
        10: "#f2e0f5",
        30: "#9035a2",
        70: "#5f246a",
        100: "#3d1744",
      },
      gradient: {
        10: "linear-gradient(90deg, rgba(144,53,162,0.3) 0%, rgba(252,87,87,0.3) 100%)",
        30: "linear-gradient(90deg, rgba(144,53,162,1) 0%, rgba(252,87,87,0.85) 100%)",
        70: "linear-gradient(90deg, rgba(109,40,123,1) 0%, rgba(251,35,35,0.85) 100%)",
        100: "linear-gradient(90deg, rgba(75,28,85,1) 0%, rgba(230,4,4,0.85) 100%)",
      },
    },
    text: {
      body: "var(--joy-color-neutral-50)",
      title: "var(--joy-color-neutral-60)",
      disabled: "var(--joy-color-neutral-30)",
    },
    state: {
      "disabled-border": "var(--joy-color-neutral-30)",
      "disabled-background": "var(--joy-color-neutral-30)",
      focus: "var(--joy-color-secondary-50)",
      hover: "var(--joy-color-secondary-50)",
      error: "var(--joy-color-error-50)",
      "hover-error": "var(--joy-color-error-90)",
    },
    overlay: "#33333066",
    background: {
      skeleton:
        "linear-gradient(110deg, var(--joy-color-neutral-20) 8%, var(--joy-color-neutral-10) 18%, var(--joy-color-neutral-20) 33%)",
    },
    shadow: {
      base: "#18181829",
    },
  },
  core: {
    spacing: {
      1: "calc(var(--joy-core-spacing-base) * 1)",
      2: "calc(var(--joy-core-spacing-base) * 2)",
      3: "calc(var(--joy-core-spacing-base) * 3)",
      4: "calc(var(--joy-core-spacing-base) * 4)",
      5: "calc(var(--joy-core-spacing-base) * 5)",
      6: "calc(var(--joy-core-spacing-base) * 6)",
      7: "calc(var(--joy-core-spacing-base) * 7)",
      8: "calc(var(--joy-core-spacing-base) * 8)",
      9: "calc(var(--joy-core-spacing-base) * 10)",
      10: "calc(var(--joy-core-spacing-base) * 12)",
      11: "calc(var(--joy-core-spacing-base) * 14)",
      12: "calc(var(--joy-core-spacing-base) * 16)",
      base: "4px",
    },
    zIndex: {
      fixedContent: 20,
      dropdown: 23,
      backdrop: 1050,
      productTour: 1060,
      walkthrough: 1070,
      dialog: 1080,
      tooltip: 1090,
      snackbar: 1100,
    },
    radius: {
      0: "0",
      1: "2px",
      2: "4px",
      3: "8px",
      4: "16px",
      5: "32px",
      6: "50%",
    },
    elevation: {
      0: "0 0 0 0 #18181829",
      1: "0 2px 4px 0 #18181829",
      2: "0 4px 12px 0 #18181829",
      3: "0 6px 24px 0 #18181829",
      4: "0 8px 32px 0 #18181829",
    },
  },
  lineHeight: {
    small: "1.05",
    large: "1.25",
  },
  font: {
    weight: {
      normal: "500",
      bold: "700",
    },
    family: {
      base: "'Moderat', Arial, Helvetica, sans-serif",
      title: "'Agrandir Tight', Arial, Helvetica, sans-serif",
    },
    size: {
      primary: {
        100: "11px",
        200: "12px",
        300: "14px",
        400: "16px",
        600: "20px",
        800: "24px",
      },
      secondary: {
        200: "28px",
        400: "36px",
        600: "46px",
        800: "52px",
      },
    },
  },
  form: {
    border: {
      width: "2px",
    },
    field: {
      height: {
        xxsmall: "var(--joy-core-spacing-6)",
        xsmall: "var(--joy-core-spacing-8)",
        small: "var(--joy-core-spacing-9)",
        medium: "var(--joy-core-spacing-10)",
        large: "var(--joy-core-spacing-12)",
      },
      radius: {
        xxsmall: "calc(var(--joy-form-field-height-xxsmall) / 2)",
        xsmall: "calc(var(--joy-form-field-height-xsmall) / 2)",
        small: "calc(var(--joy-form-field-height-small) / 2)",
        medium: "calc(var(--joy-form-field-height-medium) / 2)",
        large: "calc(var(--joy-form-field-height-large) / 2)",
      },
      focus: {
        color: "var(--joy-color-information-50)",
        width: "2px",
        shadow:
          "0 0 0 var(--joy-form-field-focus-width) var(--joy-form-field-focus-color)",
      },
    },
  },
};
